import { render, staticRenderFns } from "./probationReviewView.vue?vue&type=template&id=72cdda8e&"
import script from "./probationReviewView.vue?vue&type=script&lang=js&"
export * from "./probationReviewView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports